import { find } from 'underscore';
import { queryFeedsByName } from './query-feeds-by-name';

const defaultValue = '<attribute value>';

export function queryFeedAttributeSampleValue({
  feedName,
  attributeName,
  edmCampaign,
  jsDataCampaign,
}) {
  return queryFeedsByName({ namePrefix: feedName, useExactMatch: true, jsDataCampaign })
    .then((feeds) => {
      if (feeds.length > 1 || feeds.length === 0) {
        return null;
      }

      const { Id, AttributeNames } = feeds[0];

      const attributeNameToUse = find(
        AttributeNames,
        name => name.toUpperCase() === attributeName.toUpperCase()
      );

      if (!attributeNameToUse) {
        return null;
      }

      const entitySet = edmCampaign.currentAccount.Feeds.$withKey(Id).FeedItems.toJSON({});

      return jsDataCampaign.FeedItem
        .findAll({ query: { entitySet }, limit: 100, select: ['Id', 'AttributeValues'] })
        .then((feedItems) => {
          const firstItemHasAttributeValue = find(feedItems, (feedItem) => {
            const { AttributeValues } = feedItem || {};

            return AttributeValues[attributeNameToUse];
          });

          if (firstItemHasAttributeValue) {
            return firstItemHasAttributeValue.AttributeValues[attributeNameToUse];
          }

          return defaultValue;
        }).catch(() => null);
    });
}
